import styled from "styled-components";

export const StyledSubjectVideosGrid = styled.div`
display: grid;
grid-template-columns: repeat(auto-fit, minmax(15.46rem, 1fr));
grid-column-gap: 2.78rem;
grid-row-gap: 2.81rem;
`;